module.exports = __webpack_public_path__ + "img/has-invite.bf5f6d5c.svg";